import { Box, Button, IconButton, Typography } from "@mui/material"
import { CustomPaper } from "../../../../../CustomPaper"
import BaseModal from "../../../../../modal/baseModal"
import { useStyles } from "./styles"
import { icons } from "../../../../../../utils/icons"
import { CSSProperties, ReactElement, useMemo, useState } from "react"
import { ChooseProps, ChooseTypes } from "./types"
import { chooseTypes } from "./contants"
import { Pickers } from "./picker"
import { Selects } from "./selects"
import { FormProvider, useForm, SubmitHandler } from "react-hook-form"
import dayjs, { Dayjs } from "dayjs"
import { PickerProps } from "./picker/types"
import { SelectsProps } from "./selects/types"

type PickerOmit = Omit<PickerProps, 'name'>

const handleChoose = ({ type, payload, name }: { type: ChooseTypes; name: string; payload?: PickerOmit | SelectsProps }): ReactElement => {
    if (type == chooseTypes.picker) return <Pickers {...{ ...payload as PickerOmit, name }} />
    if (type == chooseTypes.select) return <Selects {...{ ...payload as SelectsProps, name }} />
    return <></>
}

const ChooseEditMode = ({ open, name, title, defaultValue, payload, cancel, getFormat }: ChooseProps) => {
    const value = defaultValue ? defaultValue : dayjs()
    const methods = useForm({
        defaultValues: {
            [`${name}-date`]: value,
            [`${name}-time`]: value,
            [`${name}`]: value,
        }
    })
    
    const badDate = methods.watch('bad-date')
    const styles = useStyles()
    const [choose, setChoose] = useState<ChooseTypes>(chooseTypes.picker)
    const children = useMemo(() => handleChoose({ type: choose, name, payload }), [choose, name, payload])

    const changeOfType = () => {
        if (choose == chooseTypes.picker) {
            const fecha = formatDate()
            methods.setValue(name, fecha)
        } else {
            let date = methods.getValues(name)
            // if(!!payload?.is?.start) {

            // }
            methods.setValue(`${name}-date`, date)
            methods.setValue(`${name}-time`, date)
        }
        setChoose(choose == chooseTypes.picker ? chooseTypes.select : chooseTypes.picker)
    }

    const onSubmit: SubmitHandler<Record<string, Dayjs>> = (e) => {
        let fecha: Dayjs
        if (choose == chooseTypes.picker) {
            fecha = formatDate()
        } else {
            fecha = methods.getValues(name)
        }
        getFormat(fecha)
        onCancel()
    }

    const formatDate = () => {
        const fecha1 = methods.getValues(`${name}-date`) ?? dayjs()
        const fecha2 = methods.getValues(`${name}-time`) ?? dayjs()
        const date = fecha1?.format('YYYY-MM-DD')
        const time = fecha2?.format('HH:mm:ss')
        const formatoFecha = 'YYYY-MM-DD HH:mm:ss';
        const fecha = dayjs(`${date} ${time}`, formatoFecha)

        return fecha
    }
    const onCancel = () => {
        methods.reset()
        setChoose(chooseTypes.picker)
        cancel()
    }

    return (
        <BaseModal sx={styles.root} open={open}>
            <CustomPaper elevation={0} sx={styles.container}>
                <IconButton disabled={!!badDate} onClick={changeOfType} sx={styles.editBackground}>{icons(choose == chooseTypes.picker ? 'edit' : 'calendar')}</IconButton>

                <FormProvider {...methods}>
                    <form style={styles.form as CSSProperties} onSubmit={methods.handleSubmit(onSubmit)}>
                        <Box sx={styles.body}>
                            <Typography sx={styles.title}>{title}</Typography>

                            <Box sx={{ display: 'flex', width: '100%', height: 'fit-content' }}>{children}</Box>
                        </Box>

                        <Box sx={styles.footer}>
                            <Button onClick={onCancel} className="red">CANCELAR</Button>

                            <Button disabled={!!badDate} type="submit" className="blue">SELECCIONAR</Button>
                        </Box>
                    </form>
                </FormProvider>
            </CustomPaper>
        </BaseModal>
    )
}

export { ChooseEditMode }